// Record edit form functionality
function initializeEditResultInputType(recordId) {
    const resultTypeField = document.getElementById('edit-result-type-' + recordId);
    const toggle = document.getElementById('edit-result-toggle-' + recordId);
    if (resultTypeField && toggle) {
        const resultType = resultTypeField.value || 'time';
        toggle.checked = (resultType === 'text');
        toggleEditResultInputType(recordId);
    }
}

window.toggleEditResultInputType = function(recId) {
    const toggle = document.getElementById('edit-result-toggle-' + recId);
    const timeInputWrapper = document.getElementById('edit-result-time-' + recId);
    const textInput = document.getElementById('edit-result-text-' + recId);
    const quickButtons = document.getElementById('edit-result-quick-buttons-' + recId);
    const resultTypeField = document.getElementById('edit-result-type-' + recId);
    const isTimeInput = !toggle.checked;
    
    if (timeInputWrapper && textInput) {
        const timeInputElement = timeInputWrapper.querySelector('input.time-input') || timeInputWrapper.querySelector('input');
        
        if (isTimeInput) {
            const textValue = textInput.value || '';
            if (timeInputElement) {
                timeInputElement.value = textValue;
                timeInputElement.setAttribute('name', 'result');
                timeInputElement.dispatchEvent(new Event('input', { bubbles: true }));
            }
            timeInputWrapper.style.display = '';
            textInput.style.display = 'none';
            textInput.removeAttribute('name');
            if (quickButtons) quickButtons.style.display = 'flex';
            if (resultTypeField) {
                resultTypeField.value = 'time';
            }
        } else {
            // Switching to text input - preserve text input's initial value if it exists
            // This is important when editing a record with result_type='text'
            const textInputInitialValue = textInput.getAttribute('value') || textInput.value || '';
            let timeValue = '';
            if (timeInputElement) {
                timeValue = timeInputElement.value || '';
                timeInputElement.removeAttribute('name');
            }
            // Only use time value if text input doesn't have an initial value
            // This preserves the original value when editing a text-type record
            textInput.value = textInputInitialValue || timeValue;
            timeInputWrapper.style.display = 'none';
            textInput.style.display = '';
            textInput.setAttribute('name', 'result');
            if (quickButtons) quickButtons.style.display = 'none';
            if (resultTypeField) {
                resultTypeField.value = 'text';
            }
        }
    }
};

window.setEditQuickTime = function(recId, time) {
    const timeInput = document.getElementById('edit-result-time-' + recId) || document.getElementById('id_result_time');
    if (!timeInput) return;
    
    const parseTime = (t) => {
        if (!t) return 0;
        const parts = t.trim().split(':').map(p => parseInt(p, 10) || 0);
        return (parts[0] || 0) * 3600 + (parts[1] || 0) * 60 + (parts[2] || 0);
    };
    
    const formatTime = (s) => {
        const h = Math.floor(s / 3600);
        const m = Math.floor((s % 3600) / 60);
        const sec = s % 60;
        return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
    };

    const totalSeconds = parseTime(timeInput.value) + parseTime(time);
    timeInput.value = formatTime(totalSeconds);

    timeInput.dispatchEvent(new Event('input', { bubbles: true }));
    timeInput.dispatchEvent(new Event('blur', { bubbles: true }));
};

// Record create form functionality
function getTimeInputElement(timeInputWrapper) {
    // Vue component renders input inside, find it
    if (timeInputWrapper && timeInputWrapper.tagName === 'TIME-INPUT') {
        const input = timeInputWrapper.querySelector('input.time-input');
        if (input) {
            return input;
        }
        // Fallback: try to find any input
        return timeInputWrapper.querySelector('input');
    }
    return null;
}

function initializeResultInputType() {
    const resultTypeField = document.getElementById('id_result_type');
    const toggle = document.getElementById('result_input_toggle');
    if (resultTypeField && toggle) {
        const resultType = resultTypeField.value || 'time';
        // Set toggle state: checked means text mode, unchecked means time mode
        toggle.checked = (resultType === 'text');
        // Trigger toggle to set up the UI correctly
        toggleResultInputType();
    }
}

window.toggleResultInputType = function() {
    const toggle = document.getElementById('result_input_toggle');
    const timeInputWrapper = document.getElementById('id_result_time');
    const textInput = document.getElementById('id_result_text');
    const quickButtons = document.getElementById('result_quick_buttons');
    const resultTypeField = document.getElementById('id_result_type');
    const isTimeInput = !toggle.checked;
    
    // Sync values before switching
    if (timeInputWrapper && textInput) {
        const timeInputElement = getTimeInputElement(timeInputWrapper);
        
        if (isTimeInput) {
            // Switching to time input - copy value from text to time
            const textValue = textInput.value || '';
            if (timeInputElement) {
                timeInputElement.value = textValue;
                timeInputElement.setAttribute('name', 'result');
                // Trigger input event to update Vue component
                timeInputElement.dispatchEvent(new Event('input', { bubbles: true }));
            }
            timeInputWrapper.style.display = '';
            textInput.style.display = 'none';
            textInput.removeAttribute('name');
            quickButtons.style.display = 'flex';
            // Set result type to 'time' for validation
            if (resultTypeField) {
                resultTypeField.value = 'time';
            }
        } else {
            // Switching to text input - copy value from time to text
            let timeValue = '';
            if (timeInputElement) {
                timeValue = timeInputElement.value || '';
                timeInputElement.removeAttribute('name');
            }
            textInput.value = timeValue;
            timeInputWrapper.style.display = 'none';
            textInput.style.display = '';
            textInput.setAttribute('name', 'result');
            quickButtons.style.display = 'none';
            // Set result type to 'text' for validation
            if (resultTypeField) {
                resultTypeField.value = 'text';
            }
        }
    }
};

// Initialize record create form on page load
function initializeRecordCreateForm() {
    const createForm = document.querySelector('.records-form:not(.record-edit-form)');
    if (createForm) {
        setTimeout(initializeResultInputType, 100);
    }
}

// Initialize all record edit forms on page load
function initializeRecordEditForms() {
    const editForms = document.querySelectorAll('.record-edit-form');
    editForms.forEach(form => {
        const recordId = form.getAttribute('data-record-id');
        if (recordId) {
            setTimeout(() => initializeEditResultInputType(recordId), 100);
        }
    });
}

// Use MutationObserver to watch for dynamically added edit forms and create forms
function setupRecordEditObserver() {
    const editFormObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === 1) { // Element node
                    // Check for edit forms
                    if (node.classList && node.classList.contains('record-edit-form')) {
                        const recordId = node.getAttribute('data-record-id');
                        if (recordId) {
                            setTimeout(() => initializeEditResultInputType(recordId), 100);
                        }
                    }
                    // Check for create forms
                    if (node.classList && node.classList.contains('records-form') && !node.classList.contains('record-edit-form')) {
                        setTimeout(() => initializeResultInputType(), 100);
                    }
                    // Also check for nested forms
                    const nestedEditForms = node.querySelectorAll && node.querySelectorAll('.record-edit-form');
                    if (nestedEditForms) {
                        nestedEditForms.forEach(form => {
                            const recordId = form.getAttribute('data-record-id');
                            if (recordId) {
                                setTimeout(() => initializeEditResultInputType(recordId), 100);
                            }
                        });
                    }
                    const nestedCreateForms = node.querySelectorAll && node.querySelectorAll('.records-form:not(.record-edit-form)');
                    if (nestedCreateForms) {
                        nestedCreateForms.forEach(() => {
                            setTimeout(() => initializeResultInputType(), 100);
                        });
                    }
                }
            });
        });
    });

    editFormObserver.observe(document.body, { childList: true, subtree: true });
}

// Mobile/desktop table visibility logic
function setupRecordsTableVisibility() {
    function isMobileDevice() {
        return window.matchMedia('(max-width: 570px)').matches;
    }
    
    function removeTable() {
        if (isMobileDevice()) {
            const desktopTable = document.querySelector('.records-full-width');
            if (desktopTable) {
                desktopTable.remove();
            }
        } else {
            const mobileTable = document.querySelector('.records-mobile');
            if (mobileTable) {
                mobileTable.remove();
            }
        }
    }
    
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', removeTable);
    } else {
        removeTable();
    }
}

// Record table functionality
function setupRecordsTable() {
    function updateRecordDisplay(recordElement, data) {
        const isMobile = recordElement.classList.contains('record-card-mobile');
        
        if (isMobile) {
            const titleEl = recordElement.querySelector('.record-card-mobile-title-text');
            const resultEl = recordElement.querySelector('.record-card-mobile-result-value');
            const locationEl = recordElement.querySelector('.record-card-mobile-location');
            const dateEl = recordElement.querySelector('.record-card-mobile-date');
            const distanceEl = recordElement.querySelector('.record-card-mobile-distance');
            
            if (titleEl && data.record.title) titleEl.textContent = data.record.title;
            if (resultEl && data.record.result) resultEl.textContent = data.record.result;
            if (distanceEl && data.record.distance) distanceEl.textContent = data.record.distance;
            if (locationEl) {
                if (data.record.location !== undefined) {
                    locationEl.textContent = data.record.location;
                    locationEl.style.display = data.record.location ? 'block' : 'none';
                }
            }
            
            if (dateEl && data.record.date) {
                const dateParts = data.record.date.split('-');
                if (dateParts.length === 3) {
                    const day = dateParts[2];
                    const month = dateParts[1];
                    const year = dateParts[0];
                    dateEl.textContent = `${day}.${month}.${year}`;
                }
            }
        } else {
            const titleCell = recordElement.querySelector('.record-title-cell');
            const resultCell = recordElement.querySelector('.record-result-cell');
            const locationCell = recordElement.querySelector('.record-location-cell');
            const dateCell = recordElement.querySelector('.record-date-cell');
            const distanceCell = recordElement.querySelector('.record-distance-cell');
            const sportCell = recordElement.querySelector('.record-sport-cell');
            
            if (titleCell && data.record.title) titleCell.textContent = data.record.title;
            if (resultCell && data.record.result) resultCell.textContent = data.record.result;
            if (distanceCell && data.record.distance) distanceCell.textContent = data.record.distance;
            if (locationCell && data.record.location !== undefined) locationCell.textContent = data.record.location;
            if (sportCell && data.record.sport) {
                const sportNames = {
                    'running': 'Бег',
                    'cycling': 'Велоспорт',
                    'swimming': 'Плавание',
                    'triathlon': 'Триатлон',
                    'other': 'Другое'
                };
                sportCell.textContent = sportNames[data.record.sport] || data.record.sport;
            }
            
            if (dateCell && data.record.date) {
                const dateParts = data.record.date.split('-');
                if (dateParts.length === 3) {
                    const year = parseInt(dateParts[0], 10);
                    const month = parseInt(dateParts[1], 10) - 1;
                    const day = parseInt(dateParts[2], 10);
                    const date = new Date(year, month, day);
                    
                    const dayStr = date.getDate().toString().padStart(2, '0');
                    const monthNames = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 
                                      'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
                    const monthStr = monthNames[date.getMonth()];
                    const yearStr = date.getFullYear().toString();
                    
                    const dayDiv = dateCell.querySelector('.post-event-date-day');
                    const monthDiv = dateCell.querySelector('.post-event-date-month');
                    const yearDiv = dateCell.querySelector('.post-event-date-year');
                    
                    if (dayDiv) dayDiv.textContent = dayStr;
                    if (monthDiv) monthDiv.textContent = monthStr;
                    if (yearDiv) yearDiv.textContent = yearStr;
                }
            }
        }
    }

    function toggleEditSection(button) {
        const recordElement = button.closest('.record-row') || button.closest('.record-card-mobile');
        const recordId = button.getAttribute('data-record-id');
        const isMobile = button.className.includes('mobile');
        
        if (!recordId) {
            console.warn('Record ID not found for button', button);
            return;
        }
        
        const allEditSections = document.querySelectorAll('.record-edit-mobile, .record-edit-row');
        let editSection = null;
        
        for (let section of allEditSections) {
            const sectionRecordId = section.getAttribute('data-record-id');
            if (sectionRecordId === recordId) {
                editSection = section;
                break;
            }
        }
        
        if (!editSection) {
            console.warn('Edit section not found for record ID:', recordId);
            return;
        }
        
        const isHidden = editSection.classList.contains('is-hidden');
        
        if (isHidden) {
            editSection.classList.remove('is-hidden');
            if (recordElement) {
                recordElement.classList.add('record-edit-active');
            }
        } else {
            editSection.classList.add('is-hidden');
            if (recordElement) {
                recordElement.classList.remove('record-edit-active');
            }
        }
    }

    function handleButtonClick(e) {
        // Check if clicked element is the button or inside it
        let button = e.target.closest('.record-actions-button');
        
        // Also check if the click is directly on the button text
        if (!button && e.target.classList.contains('record-actions-button')) {
            button = e.target;
        }
        
        if (button) {
            e.preventDefault();
            e.stopPropagation();
            toggleEditSection(button);
            return true;
        }
        return false;
    }

    // Handle both click and touch events for mobile compatibility
    document.addEventListener('click', function(e) {
        if (handleButtonClick(e)) {
            return;
        }
        
        const cancelButton = e.target.closest('.record-edit-cancel');
        if (cancelButton) {
            e.preventDefault();
            const recordId = cancelButton.dataset.recordId;
            if (recordId) {
                const recordElement = document.querySelector('.record-row[data-record-id="' + recordId + '"]') || 
                                     document.querySelector('.record-card-mobile[data-record-id="' + recordId + '"]');
                const editRow = document.querySelector('.record-edit-row[data-record-id="' + recordId + '"]');
                const editMobile = document.querySelector('.record-edit-mobile[data-record-id="' + recordId + '"]');
                const editSection = editRow || editMobile;
                if (editSection) {
                    editSection.classList.add('is-hidden');
                }
                if (recordElement) {
                    recordElement.classList.remove('record-edit-active');
                }
            }
        }
    });

    document.addEventListener('submit', function(e) {
        const form = e.target.closest('.record-edit-form');
        if (!form) return;
        
        e.preventDefault();
        
        const recordId = form.dataset.recordId;
        if (!recordId) return;
        
        const recordElement = document.querySelector('.record-row[data-record-id="' + recordId + '"]') || 
                             document.querySelector('.record-card-mobile[data-record-id="' + recordId + '"]');
        if (!recordElement) return;
        
        const formData = new FormData(form);
        
        const distanceSelect = form.querySelector('simple-select[id^="edit-distance-"]');
        if (distanceSelect) {
            const distanceId = distanceSelect.id;
            const distanceInput = form.querySelector('input[type="hidden"][name="' + distanceId + '"]');
            if (distanceInput && distanceInput.value) {
                formData.set('distance', distanceInput.value);
            }
        }
        
        const sportHidden = form.querySelector('input[type="hidden"][name="sport"]');
        if (sportHidden && sportHidden.value) {
            formData.set('sport', sportHidden.value);
        }
        
        const editUrl = form.action;
        if (!editUrl) return;
        
        fetch(editUrl + '?is_ajax=true', {
            method: 'POST',
            credentials: 'include',
            body: formData,
        }).then(res => res.json()).then(data => {
            if (data && data.success) {
                updateRecordDisplay(recordElement, data);
                
                const editRow = document.querySelector('.record-edit-row[data-record-id="' + recordId + '"]');
                const editMobile = document.querySelector('.record-edit-mobile[data-record-id="' + recordId + '"]');
                const editSection = editRow || editMobile;
                if (editSection) {
                    editSection.classList.add('is-hidden');
                }
                if (recordElement) {
                    recordElement.classList.remove('record-edit-active');
                }
                
                if (data.record.is_visible === false) {
                    recordElement.remove();
                    if (editSection) editSection.remove();
                }
            } else if (data && data.error) {
                alert('Ошибка: ' + data.error);
            }
        }).catch(error => {
            console.error('Error updating record:', error);
            alert('Произошла ошибка при сохранении рекорда');
        });
    });

    document.addEventListener('click', function(e) {
        const deleteButton = e.target.closest('.record-edit-delete');
        if (deleteButton) {
            e.preventDefault();
            
            if (!confirm('Вы уверены, что хотите удалить этот рекорд?')) {
                return;
            }
            
            const recordId = deleteButton.dataset.recordId;
            const deleteUrl = deleteButton.dataset.deleteUrl;
            
            if (!recordId || !deleteUrl) return;
            
            const recordElement = document.querySelector('.record-row[data-record-id="' + recordId + '"]') || 
                                 document.querySelector('.record-card-mobile[data-record-id="' + recordId + '"]');
            const editRow = document.querySelector('.record-edit-row[data-record-id="' + recordId + '"]');
            const editMobile = document.querySelector('.record-edit-mobile[data-record-id="' + recordId + '"]');
            const editSection = editRow || editMobile;
            
            fetch(deleteUrl + '?is_ajax=true', {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'X-CSRFToken': document.querySelector('[name=csrfmiddlewaretoken]').value
                }
            }).then(res => res.json()).then(data => {
                if (data && data.success) {
                    if (recordElement) recordElement.remove();
                    if (editSection) editSection.remove();
                } else if (data && data.error) {
                    alert('Ошибка: ' + data.error);
                }
            }).catch(error => {
                console.error('Error deleting record:', error);
                alert('Произошла ошибка при удалении рекорда');
            });
        }
    });

    // Also handle touch events for mobile devices
    document.addEventListener('touchend', function(e) {
        handleButtonClick(e);
    });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        initializeRecordEditForms();
        setupRecordEditObserver();
        initializeRecordCreateForm();
        setupRecordsTableVisibility();
        setupRecordsTable();
    });
} else {
    initializeRecordEditForms();
    setupRecordEditObserver();
    initializeRecordCreateForm();
    setupRecordsTableVisibility();
    setupRecordsTable();
}

